import { Center, Loader } from '@mantine/core';

const PageLoader = () => (
  <Center h="100vh">
    <Loader size="lg" />
  </Center>
);

export default PageLoader;
